module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-368.d5d7e06.woff2";